import React, { useEffect, useState } from 'react'
import SalesRetur from '../SalesRetur'
import { useDispatch } from 'react-redux'
import { getSalesMarketingReturStatus } from '../../../../models/sales/marketing/sales_marketing_retur_m';

import Paginate from '../../../pagination/Paginate';
import Moment from 'react-moment';

import { NumericFormat } from 'react-number-format';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const SalesReturValidasi = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [retur, setRetur] = useState([]);
    const [pagination, setPagination] = useState([]);

    const getData = async(page) => {
        try {
            const data = {
                status: 'belum',
                page: page
            }
            const response = await dispatch(getSalesMarketingReturStatus(data)).unwrap().catch((err) => {});
            setRetur(response.data);
            setPagination(response.pagination);
        } catch (error) {
            
        }
    }

    useEffect(() => {
        getData(1);
    }, []);

    const handlePagination = (_, page) => {
        return getData(page);
    }

    const onDetail = (code) => {
        return navigate(`${code}`);
    }

    return (
        <SalesRetur>
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                            <div style={{lineHeight: '60%'}}>
                                <h3>VALIDASI RETUR PENJUALAN</h3>
                                <span>List Validasi Retur Penjualan</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive mb-3">
                            <table className="table align-middle">
                                <thead>
                                    <tr>
                                        <th className="table-border-start text-center" style={{width: '5%'}}>
                                            <span className="form-control">No</span>
                                        </th>
                                        <th>
                                            <span className="form-control">Kode Retur</span>
                                        </th>
                                        <th>
                                            <span className="form-control">Tanggal</span>
                                        </th>
                                        <th>
                                            <span className="form-control">Marketing</span>
                                        </th>
                                        <th>
                                            <span className="form-control">Nominal</span>
                                        </th>
                                        <th className="table-border-end text-center" style={{width: '10%'}}>
                                            <span className="form-control">Action</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        retur.map((data) => (
                                            <tr key={data.no}>
                                                <td className="text-center">{data.no}</td>
                                                <td>{data.code}</td>
                                                <td>
                                                    <Moment format="dddd, DD MMMM YYYY">{data.date}</Moment>
                                                </td>
                                                <td>{data.marketing}</td>
                                                <td>
                                                    <NumericFormat 
                                                        value={ data.nominal } 
                                                        allowLeadingZeros 
                                                        thousandSeparator="," 
                                                        valueIsNumericString
                                                        prefix="Rp. "
                                                        displayType="text"
                                                        renderText={(value) => <span>{value}</span>}
                                                    />
                                                </td>
                                                <td className="text-center">
                                                    <Button onClick={() => onDetail(data.code)} variant="contained" color="primary">
                                                        Validasi
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>

                        {/* pagination */}
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <span>Halaman : { pagination.current_page }</span>
                            </div>
                            {
                                pagination.pagination ? 
                                <Paginate count={pagination.total} page={pagination.current_page} onChange={handlePagination} /> : ''
                            }
                            <div>
                                <span>Total : { pagination.total } Data</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SalesRetur>
    )
}

export default SalesReturValidasi
